<template>
  <div class="main-layout">
    <navbar v-if="user"/>

    <div class="container mt-4 col-10">
      <child/>
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/Navbar'
import { mapGetters } from "vuex";

export default {
  name: 'MainLayout',

  computed: mapGetters({
    user: "auth/user"
  }),

  components: {
    Navbar
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/layouts/default.vue